// extracted by mini-css-extract-plugin
export default {"root":"Popper_root__PYQvY","fade-in":"Popper_fade-in__phi8-","paper":"Popper_paper__rGfLR","backdrop":"Popper_backdrop__T4+yc"};